import { defineMessages } from '@atlassian/jira-intl';

export default defineMessages({
	flagEnabledIconLabel: {
		id: 'software-releases-version-detail-issue-list.issues.issue-card.feature-flags.single-flag.icons.flag-enabled-icon-label',
		defaultMessage: 'Feature flag enabled',
		description: 'Label for an icon that indicates a feature flag is enabled.',
	},
	flagDisabledIconLabel: {
		id: 'software-releases-version-detail-issue-list.issues.issue-card.feature-flags.single-flag.icons.flag-disabled-icon-label',
		defaultMessage: 'Feature flag disabled',
		description: 'Label for an icon that indicates a feature flag is disabled.',
	},
});
